export const COUNTRY_NAMES = {
  AIA: 'Anguilla',
  ANT: 'Antigua and Barbuda',
  AUS: 'Australia',
  BAH: 'Bahamas',
  BAN: 'Bangladesh',
  BAR: 'Barbados',
  BER: 'Bermuda',
  BDI: 'Burundi',
  BIZ: 'Belize',
  BOT: 'Botswana',
  BRU: 'Brunei Darussalam',
  IVB: 'British Virgin Islands',
  CAN: 'Canada',
  CAY: 'Cayman Islands',
  CMR: 'Cameroon',
  COK: 'Cook Islands',
  CYP: 'Cyprus',
  DMA: 'Dominica',
  ENG: 'England',
  FIJ: 'Fiji',
  FLK: 'Falkland Islands',
  GAB: 'Gabon',
  GAM: 'The Gambia',
  GGY: 'Guernsey',
  GIB: 'Gibraltar',
  GHA: 'Ghana',
  GRN: 'Grenada',
  GUY: 'Guyana',
  IND: 'India',
  IOM: 'Isle of Man',
  JAM: 'Jamaica',
  JEY: 'Jersey',
  KEN: 'Kenya',
  KIR: 'Kiribati',
  LCA: 'Saint Lucia',
  LES: 'Lesotho',
  MAS: 'Malaysia',
  MAW: 'Malawi',
  MDV: 'Maldives',
  MLT: 'Malta',
  MOZ: 'Mozambique',
  MRI: 'Mauritius',
  MSR: 'Montserrat',
  NAM: 'Namibia',
  NFK: 'Norfolk Island',
  NGR: 'Nigeria',
  NIR: 'Northern Ireland',
  NIU: 'Niue',
  NRU: 'Nauru',
  NZL: 'New Zealand',
  PAK: 'Pakistan',
  PNG: 'Papua New Guinea',
  RSA: 'South Africa',
  RWA: 'Rwanda',
  SAM: 'Samoa',
  SCO: 'Scotland',
  SEY: 'Seychelles',
  SHN: 'St Helena',
  SGP: 'Singapore',
  SKN: 'Saint Kitts and Nevis',
  SOL: 'Solomon Islands',
  SLE: 'Sierra Leone',
  SRI: 'Sri Lanka',
  SWZ: 'Eswatini',
  SVG: 'Saint Vincent and the Grenadines',
  TAN: 'Tanzania',
  TCA: 'Turks and Caicos Islands',
  TGA: 'Tonga',
  TOG: 'Togo',
  TTO: 'Trinidad and Tobago',
  TUV: 'Tuvalu',
  UGA: 'Uganda',
  VAN: 'Vanuatu',
  VIN: 'Saint Vincent and the Grenadines',
  WAL: 'Wales',
  ZAM: 'Zambia'
};

export const getCountryName = (code) => {
  if (!code) return '';
  return COUNTRY_NAMES[code] || code;
};
